import { getField, updateField } from 'vuex-map-fields'

import {
  TOGGLE_DRAWER,
  SET_DRAWER,
  TOGGLE_TOP_BANNER,
  SET_SITE_POPUP_VISIBILITY,
  SET_BOTTOM_BANNER_VISIBILITY,
  HIDE_EMAIL_MODAL,
  SHOW_EMAIL_MODAL,
} from '@constants/mutations'
export const state = {
  isDrawerOpen: false,
  isTopBannerOpen: true,
  isEmailModalOpen: false,
  isSitePopupOpen: true,
  isBottomBannerOpen: true,
  isOrderDialogOpen: false,
  orderDialogSelectedLocation: null,
}

export const getters = {
  getDrawerState: (state) => state.isDrawerOpen, // getDrawerState
  getTopBannerState: (state, _, __, rootGetters) =>
    state.isTopBannerOpen && rootGetters['site/getShowTopBanner'], // getTopBannerState
  getEmailModalState: (state) => state.isEmailModalOpen, // getEmailModalState
  getSitePopupState: (state, _, __, rootGetters) =>
    state.isSitePopupOpen && rootGetters['site/getShowPopup'], // getSitePopupState
  getBottomBannerState: (state, _, __, rootGetters) =>
    state.isBottomBannerOpen && rootGetters['site/getShowBottomBanner'], // getBottomBannerState
  getField,
}

export const mutations = {
  [TOGGLE_DRAWER](state) {
    state.isDrawerOpen = !state.isDrawerOpen
  },
  [SET_DRAWER](state, val) {
    state.isDrawerOpen = val
  },
  [TOGGLE_TOP_BANNER](state) {
    state.isTopBannerOpen = !state.isTopBannerOpen
  },
  [SET_SITE_POPUP_VISIBILITY](state, isVisible) {
    state.isSitePopupOpen = isVisible
  },
  [SET_BOTTOM_BANNER_VISIBILITY](state, isVisible) {
    state.isBottomBannerOpen = isVisible
  },
  [HIDE_EMAIL_MODAL](state) {
    state.isEmailModalOpen = false
  },
  [SHOW_EMAIL_MODAL](state) {
    state.isEmailModalOpen = true
  },
  updateField,
}

export const actions = {
  toggleTopBanner({ commit }) {
    commit(TOGGLE_TOP_BANNER)
  },
  showEmailModal({ commit }) {
    commit(SHOW_EMAIL_MODAL)
  },
  hideEmailModal({ commit }) {
    commit(HIDE_EMAIL_MODAL)
  },
  setSitePopup({ commit }, isVisible) {
    commit(SET_SITE_POPUP_VISIBILITY, isVisible)
  },
  setBottomBanner({ commit }, isVisible) {
    commit(SET_BOTTOM_BANNER_VISIBILITY, isVisible)
  },
}
